/* The one client every control reaches for.
 *
 * Passing it down through props would mean every control between a form and a
 * Link field has to know about the API, which is how a control ends up with
 * seven props it does not use.
 */
import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'
import type { ErpClient } from './api'

const Ctx = createContext<ErpClient | null>(null)

export function ErpProvider({ client, children }: { client: ErpClient; children: ReactNode }) {
  return <Ctx.Provider value={client}>{children}</Ctx.Provider>
}

export function useErp(): ErpClient {
  const client = useContext(Ctx)
  if (!client) throw new Error('useErp must be used inside <ErpProvider>')
  return client
}
